import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TemplateSlotComponent} from './template-slot.component';


@NgModule({
  declarations: [TemplateSlotComponent],
  exports: [TemplateSlotComponent],
  imports: [
    CommonModule
  ]
})
export class TemplateSlotModule {
}
